import "../styles/EventAttendance.css";
import { MdLocationOn, MdCalendarToday, MdAccessTime } from "react-icons/md";
import { FaLink, FaTshirt  } from "react-icons/fa";

const EventDetailSection = ({ rundown = [], eventDetail }) => {

  const formatTime = (time) => {
    if (!time) return "";
    const [hour, minute] = time.split(":");
    return `${hour.padStart(2, "0")}:${minute.padStart(2, "0")}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("id-ID", { weekday: "long", day: "2-digit", month: "long", year: "numeric" });
  };

  const eventTimeRange = () => {
    if (!eventDetail?.event_start) return "";
    const start = formatTime(eventDetail.event_start);
    const end = eventDetail.event_end ? formatTime(eventDetail.event_end) : "selesai";
    return `${start} - ${end}`;
  };

  return (
    <div className="event-content">
      <div className="agenda-left">
        <h2 className="event-name">{eventDetail?.name || "Event"}</h2>
        <p className="event-desc">{eventDetail?.description || "Join our spiritual gathering filled with meditation and community bonding."}</p>
        <div className="event-info-card">
          {eventDetail?.location && (
            <div className="event-info-item">
              <span className="icon-field">
                <MdLocationOn className="event-icon" /> Lokasi:
              </span>
              <span className="value">{eventDetail.location}</span>
            </div>
          )}

          {eventDetail?.location_map && (
            <div className="event-info-item">
              <span className="icon-field">
                <FaLink className="event-icon" /> Google Maps:
              </span>
              <span className="value">
                <a href={eventDetail.location_map} target="_blank" rel="noopener noreferrer">
                  Lihat Map
                </a>
              </span>
            </div>
          )}

          {eventDetail?.date && (
            <div className="event-info-item">
              <span className="icon-field">
                <MdCalendarToday className="event-icon" /> Hari/Tanggal:
              </span>
              <span className="value">{formatDate(eventDetail.date)}</span>
            </div>
          )}

          {eventDetail?.event_start && (
            <div className="event-info-item">
              <span className="icon-field">
                <MdAccessTime className="event-icon" /> Waktu:
              </span>
              <span className="value">{eventTimeRange()}</span>
            </div>
          )}

          {eventDetail?.dress_code && (
            <div className="event-info-item">
              <span className="icon-field">
                <FaTshirt className="event-icon" /> Dress Code:
              </span>
              <span className="value">{eventDetail.dress_code}</span>
            </div>
          )}
        </div>

        <h2 className="rundown-title">Rundown</h2>
      </div>

      {/* RIGHT SIDE */}
      <div className="agenda-right">
        <div className="schedule-list">
          {rundown.length === 0 && <p>No schedule available.</p>}

          {rundown.map((item) => (
            <div key={item.id} className="schedule-item">
              <div className="schedule-time">{formatTime(item.start_time)} - {formatTime(item.end_time)}</div>
              <div className="schedule-info">
                <div className="schedule-title">{item.schedule_name}</div>
                {item.schedule_description && (
                  <div className="schedule-description">{item.schedule_description}</div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default EventDetailSection;